// import 'react-phone-number-input/style.css';
import clsx from 'clsx';
import PhoneInput from 'react-phone-number-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function PhoneNumberInput(props) {
  var label = props.label,
      name = props.name,
      value = props.value,
      onChange = props.onChange,
      error = props.error,
      error_message = props.error_message,
      disabled = props.disabled,
      className = props.className,
      country = props.country;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx('relative rounded-md border border-gray-300 bg-white px-4 pt-4 text-sm', className),
      children: [/*#__PURE__*/_jsx(PhoneInput, {
        placeholder: "",
        value: value,
        onChange: onChange,
        defaultCountry: country || 'GB',
        smartCaret: true,
        disabled: disabled
      }, country || 'GB'), label && /*#__PURE__*/_jsx("label", {
        htmlFor: name,
        className: "origin-0 -z-1 absolute left-16 top-2 text-sm text-gray-600 transition-all peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2  peer-focus:text-sm peer-focus:text-gray-600",
        children: label
      })]
    }), error && /*#__PURE__*/_jsx("p", {
      className: "text-red-error mt-2 text-xs font-bold italic leading-3",
      children: error_message
    })]
  });
}
export default PhoneNumberInput;